import React, { useState } from 'react'
import { subscribeToAlert } from '../../../../redux/actions'
import { useDispatch, useSelector } from 'react-redux'

// MUI
import {
  Grid, Typography, Button, Tooltip,
  Accordion, AccordionDetails, AccordionSummary,
  List, ListItem, ListItemText
} from '@material-ui/core'

import { OUAlertSelectionModal } from '../../modals'

// Icons
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import LibraryAddIcon from '@material-ui/icons/LibraryAdd'
import PlaylistAddCheckIcon from '@material-ui/icons/PlaylistAddCheck'
import CompareArrowsIcon from '@material-ui/icons/CompareArrows'

const LSPrefAlerts = (props) => {
  // This tab is for LearnSafe specific alerts, and is viewable by all users UNLESS the Org has chosen to opt out. The user cannot edit or delete these.
  const dispatch = useDispatch()
  const {
    classes, unitAlertInfo, GreenCheckbox,
    TreeData, truncateText, selectedKeys, fireSubscribeFailure,
    fireSubscribeSuccess, unSubscribeAlert, noSMS, formCloneSwap
  } = props

  const Permissions = useSelector(state => state.auth.permissions)

  // Opens the OU modal
  const [openUnits, setOpenUnits] = useState(false)
  const [noUnit, setNoUnit] = useState(false)
  const [noDeliveryMethod, setNoDeliveryMethod] = useState(false)

  // Temporary object holding the information for the OU modal to dispatch
  const baseUnitObject = {
    emailNotificationID: '',
    selectedUnits: [],
    sendSMS: false,
    sendEmail: false,
    isSubscribed: false
  }

  const [newUnitAlerts, setNewUnitAlerts] = useState(baseUnitObject)
  const [targetAlert, setTargetAlert] = useState({})

  // This will check to see if the alert has been subscribed to and if it has had a OU chosen for it or not and render the correct icon
  const checkOUStatus = (emailnotificationID) => {
    if (newUnitAlerts) {
      // Checks for the alert in the global alerts
      const indexG = unitAlertInfo.global.findIndex(x => x.emailNotificationID === emailnotificationID)
      // Gets that specific Alert
      const alert = unitAlertInfo.global[indexG]

      // Checks to see if the alert is in the in the unit array, meaning they have selected this alert previosuly
      if (indexG !== -1 && alert.subscribed.isSubscribed === true) {
        return (
          <PlaylistAddCheckIcon className={classes.unitIcon} color='primary' size='small' classes={{ colorPrimary: classes.blueText }} onClick={(event) => { event.stopPropagation(); handleClickOpen(alert) }} />
        )
      } else {
        return (
          <LibraryAddIcon className={classes.unitIcon} classes={{ colorPrimary: classes.greenText }} color='primary' size='small' onClick={(event) => { event.stopPropagation(); handleClickOpen(alert) }} />
        )
      }
    }
  }

  // Passes in the alert information to the OU modal
  const handleClickOpen = (alertInfo) => {
    setNewUnitAlerts({
      ...newUnitAlerts,
      emailNotificationID: alertInfo.emailNotificationID,
      selectedUnits: alertInfo.subscribed.units.map((unitInfo) => unitInfo.unitID),
      sendSMS: alertInfo.subscribed.sendSMS,
      sendEmail: alertInfo.subscribed.sendEmail,
      isSubscribed: alertInfo.subscribed.isSubscribed
    })
    setTargetAlert({ ...alertInfo.subscribed })
    setOpenUnits(true)
  }

  // The cancel button handler in the OU modal
  const handleOUCancel = () => {
    setOpenUnits(false)
    setNoDeliveryMethod(false)
    setNoUnit(false)
    setNewUnitAlerts(baseUnitObject)
  }

  // Handles the ok button in the OU modal
  const handleOUOk = () => {
    // !!TODO: this may need to handle diffrently if the org does not have SMS enabled
    if (!newUnitAlerts.selectedUnits.length && newUnitAlerts.isSubscribed) {
      setNoDeliveryMethod(false)
      setNoUnit(true)
    } else if (newUnitAlerts.selectedUnits.length && !newUnitAlerts.isSubscribed) {
      setNoUnit(false)
      setNoDeliveryMethod(true)
    } else {
      const [unitID] = selectedKeys
      const unitsToDelete = []

      targetAlert.units.forEach((targetUnitInfo) => {
        if (newUnitAlerts.selectedUnits.findIndex((selectedUnit) => selectedUnit === targetUnitInfo.unitID) === -1) {
          unitsToDelete.push(targetUnitInfo.unitID)
        }
      })

      const subscription = {
        emailNotificationID: newUnitAlerts.emailNotificationID,
        unitsToAdd: [...newUnitAlerts.selectedUnits],
        unitsToDelete: [...unitsToDelete],
        sendSMS: newUnitAlerts.sendSMS,
        sendEmail: newUnitAlerts.sendEmail,
        isSubscribed: newUnitAlerts.isSubscribed
      }

      dispatch(subscribeToAlert(unitID, subscription, handleSuccessSubscription, fireSubscribeFailure))
    }
  }

  const handleSuccessSubscription = () => {
    fireSubscribeSuccess()
    setNewUnitAlerts(baseUnitObject)
    setOpenUnits(false)
  }

  return (
    <>
      {/* This is the OU modal */}
      <OUAlertSelectionModal
        openUnits={openUnits}
        handleOUCancel={handleOUCancel}
        handleOUOk={handleOUOk}
        classes={classes}
        GreenCheckbox={GreenCheckbox}
        newUnitAlerts={newUnitAlerts}
        setNewUnitAlerts={setNewUnitAlerts}
        noSMS={noSMS}
        TreeData={TreeData}
        noUnit={noUnit}
        noDeliveryMethod={noDeliveryMethod}
      />

      <Grid container justify='center' className={classes.accordionroot}>
        <Grid item xs={12}>
          {/* This will need to map through LearnSafe alerts only (e.g. where the accountID is null) */}
          {unitAlertInfo && unitAlertInfo.global && unitAlertInfo.global.length !== 0
            ? (
              unitAlertInfo.global.map((unit) => {
                return (
                  <Accordion key={`alert-number${unit.emailNotificationID}`} elevation={3}>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-label='Expand'
                      classes={{ content: classes.AccSumm }}
                    >
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <Typography className={classes.heading} style={{ color: !unit.subscribed.isSubscribed ? '#5291fc' : '#A4D164' }}>Title:</Typography>
                        <Tooltip title={`${unit.emailNotificationName}`} placement='top' arrow enterDelay={500} enterNextDelay={500}>
                          <Typography className='ml-1' style={{ textTransform: 'none' }}>{truncateText(`${unit.emailNotificationName}`)}</Typography>
                        </Tooltip>
                      </div>
                      <div style={{ flexBasis: '33.33%', textAlign: 'center' }} className={classes.secondaryHeading}>
                        <div style={{ flexDirection: 'row', display: 'flex', justifyContent: 'space-evenly' }}>
                          <div style={{ flexDirection: 'column', display: 'flex', alignItems: 'center' }}>
                            <Typography variant='caption' style={{ textTransform: 'none', textDecoration: 'underline' }}>
                              Subscribe
                            </Typography>
                            {checkOUStatus(unit.emailNotificationID)}
                          </div>
                          {Permissions.findIndex((permissionKey) => permissionKey === 'alert-editor') !== -1
                            ? (
                              <div style={{ flexDirection: 'column', display: 'flex', alignItems: 'center' }}>
                                <Typography variant='caption' style={{ textTransform: 'none', textDecoration: 'underline' }}>
                                  Clone
                                </Typography>
                                <CompareArrowsIcon className={classes.unitIcon} color='primary' size='small' classes={{ colorPrimary: classes.blueText }} onClick={(event) => { event.stopPropagation(); formCloneSwap(unit.emailNotificationID) }} />
                              </div>
                            )
                            : (
                              <></>
                            )}
                        </div>
                      </div>
                    </AccordionSummary>
                    <AccordionDetails className={classes.accDeets}>
                      <div style={{ display: 'flex', flexDirection: 'column', width: '50%' }}>
                        <Typography variant='subtitle1' style={{ textTransform: 'none', fontWeight: 'bold' }}>
                          Alert Details:
                        </Typography>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          <Typography variant='caption' gutterBottom className={classes.secondaryHeading}>LearnSafe Preferred</Typography>
                        </div>
                        {unit.type === 'S' &&
                          <div style={{ flexDirection: 'column', display: 'flex' }}>
                            <Typography variant='caption' style={{ textTransform: 'none', fontWeight: 'bold', color: '#5291fc' }}>
                              Severity:
                            </Typography>
                            <Typography variant='caption' style={{ textTransform: 'none' }}>
                              {`${unit.minSeverity} - ${unit.maxSeverity}`}
                            </Typography>
                          </div>}
                        <div style={{ flexDirection: 'column', display: 'flex' }}>
                          <Typography variant='caption' style={{ textTransform: 'none', fontWeight: 'bold', color: '#5291fc' }}>
                            Description:
                          </Typography>
                          <Typography variant='caption' gutterBottom style={{ textTransform: 'none' }}>
                            {`${unit.emailNotificationDesc}`}
                          </Typography>
                        </div>
                        <div>
                          <div style={{ flexDirection: 'row', display: 'flex', justifyContent: 'space-between' }}>
                            <div style={{ flexDirection: 'column', display: 'flex' }}>
                              <Typography variant='caption' style={{ textTransform: 'none', fontWeight: 'bold', color: '#5291fc' }}>
                                Category:
                              </Typography>
                              <List dense className={classes.listRoot}>
                                {unit.categories.length && unit.categories.length !== 0
                                  ? (
                                    unit.categories.map((category) => {
                                      return (
                                        <ListItem
                                          key={`${unit.emailNotificationID} category number ${unit.categories.indexOf(category)}`}
                                          className={classes.listItem}
                                        >
                                          <ListItemText
                                            className={classes.listItemText}
                                            primary={
                                              <Typography variant='caption' style={{ textTransform: 'capitalize' }}>
                                                {`${category}`}
                                              </Typography>
                                            }
                                          />
                                        </ListItem>
                                      )
                                    })
                                  )
                                  : (
                                    <Typography variant='caption' gutterBottom style={{ textTransform: 'none' }}>
                                      N/A
                                    </Typography>
                                  )}
                              </List>
                            </div>
                            <div style={{ flexDirection: 'column', display: 'flex' }}>
                              <Typography variant='caption' style={{ textTransform: 'none', fontWeight: 'bold', color: '#5291fc' }}>
                                Workstation:
                              </Typography>
                              <List dense className={classes.listRoot}>
                                {unit.workstations.length && unit.workstations.length !== 0
                                  ? (
                                    unit.workstations.map((workstation) => {
                                      return (
                                        <ListItem
                                          key={`${unit.emailNotificationID} workstation number ${unit.workstations.indexOf(workstation)}`}
                                          className={classes.listItem}
                                        >
                                          <ListItemText
                                            className={classes.listItemText}
                                            primary={
                                              <Typography variant='caption' style={{ textTransform: 'capitalize' }}>
                                                {`${workstation}`}
                                              </Typography>
                                            }
                                          />
                                        </ListItem>
                                      )
                                    })
                                  )
                                  : (
                                    <Typography variant='caption' gutterBottom style={{ textTransform: 'none' }}>
                                      N/A
                                    </Typography>
                                  )}
                              </List>
                            </div>
                          </div>
                          <div style={{ flexDirection: 'row', display: 'flex', justifyContent: 'space-between' }}>
                            <div style={{ flexDirection: 'column', display: 'flex' }}>
                              <Typography variant='caption' style={{ textTransform: 'none', fontWeight: 'bold', color: '#5291fc' }}>
                                User:
                              </Typography>
                              <List dense className={classes.listRoot}>
                                {unit.users.length && unit.users.length !== 0
                                  ? (
                                    unit.users.map((user) => {
                                      return (
                                        <ListItem
                                          key={`${unit.emailNotificationID} user number ${unit.users.indexOf(user)}`}
                                          className={classes.listItem}
                                        >
                                          <ListItemText
                                            className={classes.listItemText}
                                            primary={
                                              <Typography variant='caption' style={{ textTransform: 'capitalize' }}>
                                                {`${user}`}
                                              </Typography>
                                            }
                                          />
                                        </ListItem>
                                      )
                                    })
                                  )
                                  : (
                                    <Typography variant='caption' gutterBottom style={{ textTransform: 'none' }}>
                                      N/A
                                    </Typography>
                                  )}
                              </List>
                            </div>
                          </div>
                          {
                            unit.subscribed.isSubscribed === true
                              ? (
                                <div style={{ flexDirection: 'row', display: 'flex', justifyContent: 'space-between' }}>
                                  <Button
                                    variant='contained'
                                    size='small'
                                    className={classes.greenBtn}
                                    onClick={() => { unSubscribeAlert(unit.emailNotificationID) }}
                                  >
                                    Unsubscribe
                                  </Button>
                                </div>
                              ) : (
                                <>
                                </>
                              )
                          }
                        </div>
                      </div>
                    </AccordionDetails>
                  </Accordion>
                )
              })
            )
            : (
              <Grid container justify='center' className='mt-5'>
                <Typography gutterBottom variant='h5' style={{ textTransform: 'none' }}>No LearnSafe Preferred Alerts Available</Typography>
              </Grid>
            )}
        </Grid>
      </Grid>
    </>
  )
}

export default LSPrefAlerts
